// src/contexts/AppProviders.jsx
import React from 'react'
import { AuthProvider }    from './AuthContext'
import { RecipeProvider }  from './RecipeContext'
import { PlannerProvider } from './PlannerContext'
import { SidebarProvider } from './SidebarContext'
import { SaveContext }     from './SaveContext'

export default function AppProviders({ children }) {
  return (
    <AuthProvider>
      <RecipeProvider>
        <PlannerProvider>
          <SidebarProvider>
            <SaveContext.Provider value={{ onSave: () => {}, isSaved: false }}>
              {children}
            </SaveContext.Provider>
          </SidebarProvider>
        </PlannerProvider>
      </RecipeProvider>
    </AuthProvider>
  )
}